import { type FC } from "react";

import { ArrowRight, MessageCircle, PenLine, Search, X } from "lucide-react";

import { Button } from "@/shared/components/ui/button";
import { IconButton } from "@/shared/components/ui/icon-button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/shared/components/ui/dialog";

interface ScheduleCallDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSchedule: () => void;
}

export const ScheduleCallDialog: FC<ScheduleCallDialogProps> = ({
  open,
  onOpenChange,
  onSchedule,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[480px] p-5 sm:p-8 flex flex-col gap-6 justify-center sm:justify-start">
        <div className="absolute right-4 top-4">
          <IconButton label="Close" variant="neutral" onClick={() => onOpenChange(false)}>
            <X />
          </IconButton>
        </div>
        <div className="flex flex-col gap-1">
          <DialogTitle className="text-xl font-semibold leading-[30px]">
            Your search starts with a call
          </DialogTitle>
          <p className="text-sm text-secondary">
            Book a call with your Estate Expert. On the call, we'll:
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-sm bg-brand-subtle">
              <Search className="h-3 w-3 text-brand" />
            </span>
            <span className="text-sm text-secondary">Start the searches that can begin today</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-sm bg-brand-subtle">
              <PenLine className="h-3 w-3 text-brand" />
            </span>
            <span className="text-sm text-secondary">Walk you through the forms that let us request records for you</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-sm bg-brand-subtle">
              <MessageCircle className="h-3 w-3 text-brand" />
            </span>
            <span className="text-sm text-secondary">Answer your questions about what comes next</span>
          </div>
        </div>
        <Button
          variant="brand"
          rounded
          className="w-full"
          onClick={() => {
            onOpenChange(false);
            onSchedule();
          }}
        >
          Schedule call
          <ArrowRight className="h-4 w-4" />
        </Button>
      </DialogContent>
    </Dialog>
  );
};
